import { render, staticRenderFns } from "./ForCompanies.vue?vue&type=template&id=3b53049a&scoped=true&"
import script from "./ForCompanies.vue?vue&type=script&lang=js&"
export * from "./ForCompanies.vue?vue&type=script&lang=js&"
import style0 from "./ForCompanies.vue?vue&type=style&index=0&id=3b53049a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b53049a",
  null
  
)

export default component.exports